// src/components/TransactionList.js

import React, { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { useWallet } from '@solana/wallet-adapter-react';
import './TransactionList.css';

export default function TransactionList() {
    const { publicKey } = useWallet();
    const [spinRecords, setSpinRecords] = useState([]);
    const [pullRecords, setPullRecords] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch spin records
    useEffect(() => {
        if (!publicKey) return;
        setLoading(true);
        const qSpins = query(
            collection(db, 'poem_spins'),
            // where('publicKey', '==', publicKey.toString()),
            orderBy('timestamp', 'desc')
        );
        const unsubSpins = onSnapshot(qSpins, snapshot => {
            setSpinRecords(
                snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            );
            setLoading(false);
        });
        return () => unsubSpins();
    }, [publicKey]);

    useEffect(() => {
        setLoading(true);
        const qSpins = query(
            collection(db, 'poem_spins'),
            orderBy('timestamp', 'desc')
        );
        const unsubSpins = onSnapshot(qSpins, snapshot => {
            setSpinRecords(
                snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            );
            setLoading(false);
        });
        return () => unsubSpins();
    }, []);


    // if (!publicKey) {
    //     return <p>Please connect your wallet to view transactions.</p>;
    // }
    if (loading) {
        return <p>Loading transactions...</p>;
    }

    return (
        <div className="transactions-list">
            <h2>Spin Records</h2>
            <div className="transaction-list-table-container">
                {spinRecords.length === 0 ? (
                    <p>No spin records found.</p>
                ) : (
                    <table>
                        <thead>
                        <tr>
                            <th>Timestamp</th>
                            <th>Total Score</th>
                            <th>Match Result</th>
                            <th>Poem</th>
                            <th>Image</th>
                        </tr>
                        </thead>
                        <tbody>
                        {spinRecords.map(rec => (
                            <tr key={rec.id}>
                                <td>{rec.timestamp?.toDate().toLocaleString()}</td>
                                <td>{rec.totalScore}</td>
                                <td>{rec.matchResult}</td>
                                <td><pre className="poem-text">{rec.poem}</pre></td>
                                <td>
                                    <a href={rec.detailUrl} target="_blank" rel="noopener noreferrer">
                                        View Image
                                    </a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>

            <h2>Mint Records</h2>
            <div className="transaction-list-table-container">
                {pullRecords.length === 0 ? (
                    <p>No mint records found.</p>
                ) : (
                    <table>
                        <thead>
                        <tr>
                            <th>Timestamp</th>
                            <th>Total Score</th>
                            <th>Match Result</th>
                            <th>Minted At</th>
                        </tr>
                        </thead>
                        <tbody>
                        {pullRecords.map(rec => (
                            <tr key={rec.id}>
                                <td>{rec.timestamp?.toDate().toLocaleString()}</td>
                                <td>{rec.totalScore}</td>
                                <td>{rec.matchResult}</td>
                                <td>{rec.mintedAt}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
